import React from "react";
import { Button } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { GOLD_MONTHLY_PRICE } from "@iso/constants/onboarding";

// The 3-month Gold trial offer, shown to users who picked the free plan.
const TrialOfferCard = ({ started, onTry }) => (
  <div className="ob-trial-card">
    <h2>Gold</h2>
    {started ? (
      <p className="ob-trial-started">
        <CheckCircleOutlined /> Your 3-month Gold trial has started.
      </p>
    ) : (
      <>
        <p>
          We're giving you three months free on our premium subscription.
          Your card won't be charged unless you continue after the trial, and
          you can cancel any time during the three months.
        </p>
        <div className="ob-trial-price">
          {GOLD_MONTHLY_PRICE}
          <small>/month after the trial</small>
        </div>
        <Button className="ob-trial-btn" onClick={onTry}>
          Try 3 months free
        </Button>
      </>
    )}
  </div>
);

export default TrialOfferCard;
